/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskAverageMonthlyFMVOfSec } from './ExecRiskAverageMonthlyFMVOfSec';
import {
    ExecRiskAverageMonthlyFMVOfSecFromJSON,
    ExecRiskAverageMonthlyFMVOfSecFromJSONTyped,
    ExecRiskAverageMonthlyFMVOfSecToJSON,
} from './ExecRiskAverageMonthlyFMVOfSec';
import type { ExecRiskPriorCurrentYearAmt } from './ExecRiskPriorCurrentYearAmt';
import {
    ExecRiskPriorCurrentYearAmtFromJSON,
    ExecRiskPriorCurrentYearAmtFromJSONTyped,
    ExecRiskPriorCurrentYearAmtToJSON,
} from './ExecRiskPriorCurrentYearAmt';

/**
 * 
 * @export
 * @interface ExecRiskMinimumAssetAmount
 */
export interface ExecRiskMinimumAssetAmount {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskMinimumAssetAmount
     */
    AverageMonthlyFMVOfSecGrpPriorYearAmt?: number;
    /**
     * 
     * @type {Array<ExecRiskAverageMonthlyFMVOfSec>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    AverageMonthlyFMVOfSecGrp?: Array<ExecRiskAverageMonthlyFMVOfSec>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    AverageMonthlyCashBalancesGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    FMVOtherNonExemptUseAssetGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {Array<ExecRiskPriorCurrentYearAmt>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    TotalFMVOfNonExemptUseAssetGrp?: Array<ExecRiskPriorCurrentYearAmt>;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskMinimumAssetAmount
     */
    DiscountClaimedAmt?: number;
    /**
     * 
     * @type {Array<ExecRiskAverageMonthlyFMVOfSec>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    AcquisitionIndebtednessGrp?: Array<ExecRiskAverageMonthlyFMVOfSec>;
    /**
     * 
     * @type {Array<ExecRiskAverageMonthlyFMVOfSec>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    AdjustedFMVLessIndebtednessGrp?: Array<ExecRiskAverageMonthlyFMVOfSec>;
    /**
     * 
     * @type {Array<ExecRiskAverageMonthlyFMVOfSec>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    CashDeemedCharitableGrp?: Array<ExecRiskAverageMonthlyFMVOfSec>;
    /**
     * 
     * @type {Array<ExecRiskAverageMonthlyFMVOfSec>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    NetVlNonExemptUseAssetsGrp?: Array<ExecRiskAverageMonthlyFMVOfSec>;
    /**
     * 
     * @type {Array<ExecRiskAverageMonthlyFMVOfSec>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    PctOfNetVlNonExemptUseAstGrp?: Array<ExecRiskAverageMonthlyFMVOfSec>;
    /**
     * 
     * @type {Array<ExecRiskAverageMonthlyFMVOfSec>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    RecoveriesPYDistriMinAssetGrp?: Array<ExecRiskAverageMonthlyFMVOfSec>;
    /**
     * 
     * @type {Array<ExecRiskAverageMonthlyFMVOfSec>}
     * @memberof ExecRiskMinimumAssetAmount
     */
    TotalMinimumAssetGrp?: Array<ExecRiskAverageMonthlyFMVOfSec>;
}

/**
 * Check if a given object implements the ExecRiskMinimumAssetAmount interface.
 */
export function instanceOfExecRiskMinimumAssetAmount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskMinimumAssetAmountFromJSON(json: any): ExecRiskMinimumAssetAmount {
    return ExecRiskMinimumAssetAmountFromJSONTyped(json, false);
}

export function ExecRiskMinimumAssetAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskMinimumAssetAmount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'AverageMonthlyFMVOfSecGrpPriorYearAmt': !exists(json, 'AverageMonthlyFMVOfSecGrpPriorYearAmt') ? undefined : json['AverageMonthlyFMVOfSecGrpPriorYearAmt'],
        'AverageMonthlyFMVOfSecGrp': !exists(json, 'AverageMonthlyFMVOfSecGrp') ? undefined : ((json['AverageMonthlyFMVOfSecGrp'] as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecFromJSON)),
        'AverageMonthlyCashBalancesGrp': !exists(json, 'AverageMonthlyCashBalancesGrp') ? undefined : ((json['AverageMonthlyCashBalancesGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'FMVOtherNonExemptUseAssetGrp': !exists(json, 'FMVOtherNonExemptUseAssetGrp') ? undefined : ((json['FMVOtherNonExemptUseAssetGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'TotalFMVOfNonExemptUseAssetGrp': !exists(json, 'TotalFMVOfNonExemptUseAssetGrp') ? undefined : ((json['TotalFMVOfNonExemptUseAssetGrp'] as Array<any>).map(ExecRiskPriorCurrentYearAmtFromJSON)),
        'DiscountClaimedAmt': !exists(json, 'DiscountClaimedAmt') ? undefined : json['DiscountClaimedAmt'],
        'AcquisitionIndebtednessGrp': !exists(json, 'AcquisitionIndebtednessGrp') ? undefined : ((json['AcquisitionIndebtednessGrp'] as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecFromJSON)),
        'AdjustedFMVLessIndebtednessGrp': !exists(json, 'AdjustedFMVLessIndebtednessGrp') ? undefined : ((json['AdjustedFMVLessIndebtednessGrp'] as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecFromJSON)),
        'CashDeemedCharitableGrp': !exists(json, 'CashDeemedCharitableGrp') ? undefined : ((json['CashDeemedCharitableGrp'] as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecFromJSON)),
        'NetVlNonExemptUseAssetsGrp': !exists(json, 'NetVlNonExemptUseAssetsGrp') ? undefined : ((json['NetVlNonExemptUseAssetsGrp'] as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecFromJSON)),
        'PctOfNetVlNonExemptUseAstGrp': !exists(json, 'PctOfNetVlNonExemptUseAstGrp') ? undefined : ((json['PctOfNetVlNonExemptUseAstGrp'] as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecFromJSON)),
        'RecoveriesPYDistriMinAssetGrp': !exists(json, 'RecoveriesPYDistriMinAssetGrp') ? undefined : ((json['RecoveriesPYDistriMinAssetGrp'] as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecFromJSON)),
        'TotalMinimumAssetGrp': !exists(json, 'TotalMinimumAssetGrp') ? undefined : ((json['TotalMinimumAssetGrp'] as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecFromJSON)),
    };
}

export function ExecRiskMinimumAssetAmountToJSON(value?: ExecRiskMinimumAssetAmount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'AverageMonthlyFMVOfSecGrpPriorYearAmt': value.AverageMonthlyFMVOfSecGrpPriorYearAmt,
        'AverageMonthlyFMVOfSecGrp': value.AverageMonthlyFMVOfSecGrp === undefined ? undefined : ((value.AverageMonthlyFMVOfSecGrp as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecToJSON)),
        'AverageMonthlyCashBalancesGrp': value.AverageMonthlyCashBalancesGrp === undefined ? undefined : ((value.AverageMonthlyCashBalancesGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'FMVOtherNonExemptUseAssetGrp': value.FMVOtherNonExemptUseAssetGrp === undefined ? undefined : ((value.FMVOtherNonExemptUseAssetGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'TotalFMVOfNonExemptUseAssetGrp': value.TotalFMVOfNonExemptUseAssetGrp === undefined ? undefined : ((value.TotalFMVOfNonExemptUseAssetGrp as Array<any>).map(ExecRiskPriorCurrentYearAmtToJSON)),
        'DiscountClaimedAmt': value.DiscountClaimedAmt,
        'AcquisitionIndebtednessGrp': value.AcquisitionIndebtednessGrp === undefined ? undefined : ((value.AcquisitionIndebtednessGrp as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecToJSON)),
        'AdjustedFMVLessIndebtednessGrp': value.AdjustedFMVLessIndebtednessGrp === undefined ? undefined : ((value.AdjustedFMVLessIndebtednessGrp as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecToJSON)),
        'CashDeemedCharitableGrp': value.CashDeemedCharitableGrp === undefined ? undefined : ((value.CashDeemedCharitableGrp as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecToJSON)),
        'NetVlNonExemptUseAssetsGrp': value.NetVlNonExemptUseAssetsGrp === undefined ? undefined : ((value.NetVlNonExemptUseAssetsGrp as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecToJSON)),
        'PctOfNetVlNonExemptUseAstGrp': value.PctOfNetVlNonExemptUseAstGrp === undefined ? undefined : ((value.PctOfNetVlNonExemptUseAstGrp as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecToJSON)),
        'RecoveriesPYDistriMinAssetGrp': value.RecoveriesPYDistriMinAssetGrp === undefined ? undefined : ((value.RecoveriesPYDistriMinAssetGrp as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecToJSON)),
        'TotalMinimumAssetGrp': value.TotalMinimumAssetGrp === undefined ? undefined : ((value.TotalMinimumAssetGrp as Array<any>).map(ExecRiskAverageMonthlyFMVOfSecToJSON)),
    };
}

